<template>
  <DashAlunoMobile v-if="isMobile()" />
  <DashAluno v-else/>
</template>
<script>
import DashAluno from '@/components/AlunoView/DashAluno'
import DashAlunoMobile from '@/components/AlunoView/DashAlunoMobile'

export default {
  name: 'DashAlunoSelector',
  components: {
    DashAluno,
    DashAlunoMobile
  }
}
</script>